import React from "react";
import { CampaignTeasersViewModel } from "./CampaignTeasersViewModel.csharp";

export const CampaignTeasers: React.FC<CampaignTeasersViewModel> = ({
  campaigns,
}) => {
  const teasers = campaigns.map((c, i) => (
    <div className="edge-to-edge-sm card__column-alternation-xl col-xl-9 mb-1" key={i}>
      <div className="card card-hover theme-inherit-light">
        <div className="d-flex">
          <div className="card-inner-square position-relative">
            <img src={c.imageUrl+`?width=288&height288&rmode=crop=&ranchor=${c.listingImageAnchor}`} alt="" loading="lazy" />
          </div>
          <div className="card-inner-square">
            <div className="card-inner-square__padding">
              <p className="h5 card-title mb-0">
                <a className="card-block-link" href={c.url}>
                  <span dangerouslySetInnerHTML={{ __html: c.heading.replace(/\|/g, '&shy;')}} />
                  <i className="icon icon-arrow-right"></i></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <div className="offset-lg-up">
      <div className="row row-tight">
        <h2 className="mb-2 mb-md-3">Kampanjetilbud</h2>
        <div className="edge-to-edge-sm col-sm-15 col-md-12 col-lg-9 col-xl-12">
          <div className="mb-4 mb-lg-5">
            <div className="row row-tight">
              <div className="edge-to-edge-sm col-xl-9 mb-1" aria-hidden="true">
                <div className="card theme-inherit">
                  <div className="d-flex">
                    <div className="card-inner-square position-relative">
                      <div className="card-inner-square__padding card__giant-icon">
                        <i className="icon icon-xl icon-percent"></i>
                      </div>
                    </div>
                    <div className="card-inner-square"></div>
                  </div>
                </div>
              </div>
              {teasers}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
